import { Link } from '@tanstack/react-router';
import { useNarratives } from '../hooks/queries';
import { money, pct, stanceGlyph, when } from '../hooks/format';
import { Empty, KV, Pill } from '../components/ui';

export function Home() {
  const q = useNarratives();
  if (q.isLoading) return <div className="empty">…</div>;
  const list = q.data ?? [];
  return (
    <div className="page">
      <h1 className="t-h" style={{ margin: '8px 0 14px' }}>Narratives</h1>
      {list.length === 0 && <Empty>No narratives yet. Seed one with the CLI: <span className="mono">lore intake --file …</span></Empty>}
      {list.map((n) => {
        const net = Number(n.realized_net);
        const ret = Number(n.allocation) > 0 ? net / Number(n.allocation) : null;
        return (
          <Link key={n.id} to="/n/$slug" params={{ slug: n.slug }} search={{ tab: undefined }} className="card tap">
            <div className="row">
              <div className="t-em">{n.title}</div>
              <Pill tone={n.mode === 'LIVE' ? 'live' : n.mode === 'PAPER' && n.status === 'ACTIVE' ? 'paper' : n.execution_state !== 'RUNNING' && n.status === 'ACTIVE' ? 'warn' : undefined}>
                {n.status === 'ACTIVE' ? (n.execution_state === 'RUNNING' ? n.mode : n.execution_state) : n.status}
              </Pill>
            </div>
            <div className="grid2" style={{ marginTop: 12 }}>
              <KV k="Allocated" v={money(n.allocation, n.base_currency, { dp: 0 })} />
              <KV k="Deployed" v={money(n.deployed, n.base_currency, { dp: 0 })} />
              <KV k="Realised net" v={money(n.realized_net, n.base_currency, { sign: true })} tone={net > 0 ? 'gain' : net < 0 ? 'loss' : undefined} />
              <KV k="Return" v={pct(ret)} tone={ret && ret > 0 ? 'gain' : ret && ret < 0 ? 'loss' : undefined} />
            </div>
            <hr className="hairline" />
            <div className="row t-sec">
              <span className="muted">{n.stance ? <>{stanceGlyph(n.stance)} {n.stance.toLowerCase()}{n.thesis_version ? ` · v${n.thesis_version}` : ''}</> : 'not developed'}</span>
              <span className="muted">{n.next_checkpoint ? `next ${when(n.next_checkpoint.due_at)}` : '—'}</span>
            </div>
            {n.last_event && <div className="faint t-cap" style={{ marginTop: 6, textTransform: 'none', letterSpacing: 0 }}>{n.last_event.type.replace('.', ' · ')} · {when(n.last_event.occurred_at)}</div>}
          </Link>
        );
      })}
    </div>
  );
}
